export const WhyChooseUs = () => {
  const points = [
    "Real-Time Project Experience",
    "Modern Technology Stack",
    "Affordable & Scalable Solutions",
    "Dedicated Support Team",
    "Fast Delivery & Quality Assurance",
    "End-to-End Development"
  ];

  return (
    <section className="py-24 bg-gray-50 text-center">
      <h2 className="text-4xl font-bold mb-12">
        Why Clients Choose Us
      </h2>

      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {points.map((p, i) => (
          <div key={i} className="p-6 bg-white shadow rounded-xl font-medium">
            ✔ {p}
          </div>
        ))}
      </div>
    </section>
  );
};